import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { env } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BoxService {
  currentToken: string;

  constructor(protected http: HttpClient) {}

  async getToken() {
    if (!this.currentToken) {
      const response = await this.http
        .get<{ accessToken: string; accessTokenTTLMS: number }>(`${env.APIUrl}/box/token`)
        .toPromise();
      this.currentToken = response.accessToken;

      setTimeout(
        () => {
          this.currentToken = null;
        },
        response.accessTokenTTLMS - 60 * 1000,
      );
    }
    return this.currentToken;
  }

  async download(url: string, token: string) {
    return await this.http
      .get(url, { responseType: 'blob', headers: { Authorization: `Bearer ${token}` } })
      .toPromise();
  }
}
